import React from 'react';
import { Hotel, Users, Phone, User } from 'lucide-react';

const AccommodationPage = () => {
  const committee = [
    { name: 'Dr. Manish Bhakta', role: 'Committee Member' },
    { name: 'Dr. Kuldeep Desai', role: 'Committee Member' },
    { name: 'Dr. Haresh Kheni', role: 'Committee Member' },
    { name: 'Dr. Tushar Patel', role: 'Committee Member', phone: '9909944001', isContact: true },
  ];

  return (
    <div className="min-h-screen pt-32 pb-16" data-testid="accommodation-page">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center mb-10">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">
            <span className="gradient-text">Accommodation</span>
          </h1>
          <p className="text-lg text-slate-300">Book your stay for AGOC 2026 | 24–25 October 2026, Surat</p>
        </div>

        {/* Accommodation Committee */}
        <div className="glass-card p-6 md:p-8 mb-8" data-testid="accommodation-committee">
          <h2 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
            <Users className="h-5 w-5 text-[#FF6F4A]" />
            Accommodation Committee
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {committee.map((member, i) => (
              <div key={i} className="glass-card p-4 text-center">
                <div className="w-12 h-12 mx-auto mb-2 rounded-full bg-gradient-to-br from-[#FF6F4A] to-[#FFB6C1] flex items-center justify-center">
                  <User className="h-6 w-6 text-white" />
                </div>
                <p className="text-white font-semibold text-sm">{member.name}</p>
                <p className="text-slate-400 text-xs">{member.role}</p>
                {member.isContact && (
                  <a href={`tel:${member.phone}`} className="mt-2 inline-flex items-center gap-1 text-[#FF6F4A] text-xs hover:underline" data-testid="committee-contact-phone">
                    <Phone className="h-3 w-3" /> {member.phone}
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Accommodation Requests Closed */}
        <div className="glass-card p-6 md:p-10" data-testid="accommodation-form-section">
          <h2 className="text-xl font-semibold text-white mb-2 flex items-center gap-2">
            <Hotel className="h-5 w-5 text-[#FF6F4A]" />
            Room Requirement Form
          </h2>
          <div className="mt-4 p-6 glass-card border border-red-500/30 bg-red-500/5 text-center" data-testid="accommodation-closed-banner">
            <p className="text-red-400 font-semibold text-lg mb-2">Accommodation requests are now closed</p>
            <p className="text-slate-300 text-sm">We are no longer accepting new accommodation requests online. Delegates who have already submitted a request will be contacted by our representative for confirmation.</p>
          </div>

          <div className="mt-6 pt-4 border-t border-white/10 text-center">
            <p className="text-slate-400 text-sm">
              For immediate assistance, contact <span className="text-white font-semibold">Dr. Tushar Patel</span> at{' '}
              <a href="tel:9909944001" className="text-[#FF6F4A] hover:underline font-semibold">9909944001</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccommodationPage;
